import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";

//Redux
import { connect } from "react-redux";

//Funciones

//Componentes
import Loading from "../../components/modales/loadingModal";
import AttachCardV2 from "../../components/cards/attachCardV2";
import DescargarZIPButton from "../../components/buttons/DescargarZIPButton";

//GCP Functions
import {
  getFileList,
  getFinalFileZip,
} from "../../utils/FirebaseStorage/FirebaseStorage";

import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";

//API Calls
const actualizarAPE = functionsHttpsCallable("ape_actualizarSolicitudEmpleo");
const getAPE = functionsHttpsCallable("ape_getSolicitudPorId");
//API Calls

const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

const CargarContrato = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const navigate = useNavigate();
  const [updFile, setUpdFile] = useState([]);
  const [data, setData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const ape = searchParams.get("ape");

  useEffect(() => {
    async function getData() {
      setLoading(true);
      await getInformacionSolicitud();
      await getInformacionAdjuntos();
      setLoading(false);
    }
    getData();
  }, []);

  // useEffect(() => {
  //     console.log('new file list', fileList)
  // }, [fileList])

  const fileExist = (filename) => {
    if (fileList) {
      const newArr = fileList.filter(
        (file) => file.fileName.split(".")[0] == filename
      );
      return {
        exists: newArr.length > 0,
        file: newArr.length > 0 ? newArr[0] : undefined,
      };
    } else return { exists: false, file: undefined };
  };

  const downloadZip = async () => {
    setLoading(true);
    try {
      let downloadLink = await getFinalFileZip(`APEFiles/${ape}`, userData);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
    setLoading(false);
  };

  const getInformacionAdjuntos = async () => {
    let filesList = await getFileList(`APEFiles/${ape}/`);
    setFileList(filesList);
  };

  const updateFileList = (e) => {
    console.log("temp file list", e);
  };

  const getInformacionSolicitud = async () => {
    let body = {
      solicitudId: ape,
      cod_empr: userData.codigoEmpresa ?? 537,
    };
    const APEInfo = await getAPE(body);
    if (APEInfo.data.status !== "CONSULTA_EXITOSA") {
      toastError("Hubo un problema con la solicitud");
      navigate("/home/cargueContrato");
    }
    setData(APEInfo.data.data);
  };

  const handleApprove = async () => {
    setLoading(true);
    try {
      const body = {
        cod_soli: ape,
        cod_empr: userData.codigoEmpresa,
        data: {
          cod_actu: data.flujo.cedulaContratador,
          cmp_stat: "CONTRATACION_3",
        },
      };
      await actualizarAPE(body);
      navigate("/home/cargueContrato");
    } catch (error) {
      console.log(error);
      toastError("Error actualización APE");
    }
    setLoading(false);
  };

  const fileReadyToUpload = (filename) => {
    const newArr = updFile.filter((file) => file.key === filename);
    return newArr.length > 0;
  };

  if (loading) {
    return (
      <div className={"loading-area"}>
        {" "}
        <Loading />{" "}
      </div>
    );
  } else {
    return (
      <>
        <div className="breadcum-display-content-2">
          <DescargarZIPButton
            onClick={() => {
              downloadZip();
            }}
          />
        </div>
        <div className="card-fecha-contratacion">
          <div
            style={{
              width: "100%",
              margin: "5px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            {/* <div style={{ width: '100%', marginTop: '5px', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <AttachCardV2
                                id={'CONTRATO_FIRMADO'}
                                subText={`Cargar Contrato Firmado APE ${ape}`}
                                attached={fileReadyToUpload(`CONTRATO_FIRMADO`) || fileExist(`CONTRATO_FIRMADO`).exists}
                                file={fileExist(`CONTRATO_FIRMADO`).file}
                                apeId={ape}
                                fileList={fileList}
                                setLoading={(e) => setLoading(e)}
                                setFileList={(e) => { updateFileList(e) }}
                            /> 
                        </div>*/}
            <div
              style={{
                width: "100%",
                marginTop: "5px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <AttachCardV2
                id={"DOCUMENTOS_CONTRACTUALES"}
                subText={`Documentos Contractuales APE ${ape}`}
                attached={
                  fileReadyToUpload(`MANUAL_FIRMADO`) ||
                  fileExist(`DOCUMENTOS_CONTRACTUALES`).exists
                }
                file={fileExist(`DOCUMENTOS_CONTRACTUALES`).file}
                apeId={ape}
                fileList={fileList}
                setLoading={(e) => setLoading(e)}
                setFileList={(e) => {
                  updateFileList(e);
                }}
              />
            </div>
            <div
              style={{
                width: "100%",
                marginTop: "5px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <AttachCardV2
                id={"INDUCCIONES"}
                subText={`Cargar Inducciones APE ${ape}`}
                attached={
                  fileReadyToUpload(`INDUCCIONES`) ||
                  fileExist(`INDUCCIONES`).exists
                }
                file={fileExist(`INDUCCIONES`).file}
                apeId={ape}
                fileList={fileList}
                setLoading={(e) => setLoading(e)}
                setFileList={(e) => {
                  updateFileList(e);
                }}
              />
            </div>
          </div>
          <br />
          <Button
            disabled={
              !fileExist(`INDUCCIONES`).exists ||
              !fileExist(`INDUCCIONES`).exists ||
              !fileExist(`INDUCCIONES`).exists
            }
            color="primary"
            onClick={() => handleApprove()}
          >
            {"Aprobar"}
          </Button>
        </div>
      </>
    );
  }
};

export default withAuthenticationRequired(
  connect(mapStateToProps)(CargarContrato),
  {
    onRedirecting: () => <Loading />,
  }
);
